import { memo, useState, useMemo, useEffect, useCallback, useRef } from 'react'
import { useDebounce, Dropdown, InputText } from 'ui_kit_qmd'
import { useLocation } from 'react-router-dom'
import './EditContactInfoBlock.scss'
import { useDispatch, useSelector } from 'react-redux'
import env from '../../../../../../env.json'
import { PhoneInput } from '../../../../../../components/phone-input/PhoneInput'
import {
  CONTACT_TEXT,
  INTAKE_FORM_TYPE_PHONE_NUMBER_TEXT,
  ASTERISK_TEXT,
  INTAKE_FORM_TYPE_EMAIL_TEXT,
  STREET_ADDRESS_1_TEXT,
  STREET_ADDRESS_2_TEXT,
  CITY_TEXT,
  STATE_TEXT,
  ZIP_CODE_TEXT,
  PREFERRED_PHARMACY_TEXT,
  NO_RESULTS_TEXT,
  profilePermissions,
  EMAIL_TEXT,
} from '../../../../../../utils/constants'
import { EditCardAccountInfo } from '../../../edit-card-account-info/EditCardAccountInfo'
import { PharmacyDropdownItem } from '../../../pharmacy-dropdow-item/PharmacyDropdownItem'
import { PharmacyZipFilter } from '@quickmd-llc/design-system'
import { setContactInfoState } from '../../reducers/ContactInfoReducer'
import { getAddressFieldsFromPlaceResult } from './getAddressFieldsFromPlaceResult'
import { setPharmacyAddressValue, sortedStatesAddressDropdownList } from '../../../../../../utils/common'
import {
  resetPharmacySearchList,
  setChartsError,
  setIsPharmaciesSearchingDone,
} from '../../../../../../store/charts/ChartsActions'
import { searchPharmacies, validatePhoneNumber } from '../../../../../../store/charts/ChartsThunk'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../../../../utils/errormessages'
import { selectPharmacySearchDaw } from '../../../../../../store/flags/flagsSelectors'
import { useGetPharmaciesV2 } from '../../../../../../api/generated/pharmacy-v2/pharmacy-v2'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const getPhoneNumberValue = (phoneNumberData) => {
  if (phoneNumberData) {
    return `${phoneNumberData.Number.replace(phoneNumberData.Prefix, '')}`
  }
  return ''
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
const setPharmacyString = ({ StreetAddress1, StreetAddress2, City, StateCode, Zip, CountryCode }) =>
  `${StreetAddress1}, ${StreetAddress2 ? `${StreetAddress2}, ` : ''}${City}, ${StateCode} ${Zip}, ${CountryCode}`

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const adaptationSymbolsForAPI = (textValue) =>
  encodeURIComponent(textValue).replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16)}`)

const mainInputContainerStyle = {
  width: '100%',
  marginBottom: 44,
}

const statesDropdownContainerStyle = {
  marginBottom: 0,
}

const maxWindowWidthForIncreaseZipCodeErrorHeight = 1560
const maxWindowWidthForIncreaseStreetAddress1ErrorHeight = 1835

export const EditContactInfoBlock = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    stateInfo,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    dispatchInfo,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsPhoneValidationInProgress,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsAddressChanged,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isSaveClickedBeforePhoneValidation,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isAlowEditPhoneNumber,
  }) => {
    const {
      phoneCountry,
      phoneNumber,
      phoneCountryCode,
      isPhoneCorrect,
      isOldNumberCorrect,
      streetAddress1,
      streetAddress2,
      city,
      stateCode,
      zipCode,
      pharmacyValue,
      pharmacyValueBeforeInputBlured,
      pharmacyLocalError,
      streetAddress1LocalError,
      cityLocalError,
      stateCodeLocalError,
      zipCodeLocalError,
      phoneLocalError,
      isAddressValid,
      isPhoneValidation,
      isPhoneChanged,
      forcePhoneLocalError,
      emailAddress,
      emailAddressLocalError,
    } = stateInfo || {}

    const { search } = useLocation()
    const params = new URLSearchParams(search)
    const id = params.get('id')

    const dispatch = useDispatch()

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const searchPharmaciesAction = (userId, value) => {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(searchPharmacies(userId, value))
    }

    const onSearchPharmaciesDebounce = useDebounce(searchPharmaciesAction, 500)

    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const phoneNumberValidationLoading = useSelector((state) => state.member.loading)
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const foundPharmaciesCollection = useSelector((state) => state.chartsReducer.foundPharmaciesCollection)
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const isPharmacySearchingDone = useSelector((state) => state.chartsReducer.isPharmacySearchingDone)
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const patientInfo = useSelector((state) => state.chartsReducer.patientInfo)
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const error = useSelector((state) => state.chartsReducer.error)
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const profile = useSelector((state) => state.accountSettings.adminProfile)
    const isCanEditEmail = profile?.Permissions?.includes(profilePermissions.CAN_EDIT_EMAIL)
    const isPharmacySearchDaw = useSelector(selectPharmacySearchDaw)

    const currentPatientInfo = patientInfo?.[id]
    const patientZip = currentPatientInfo?.Address?.Zip || ''

    const [pharmacySearchZip, setPharmacySearchZip] = useState(patientZip)
    const [v2SearchValue, setV2SearchValue] = useState('')

    useEffect(() => {
      setPharmacySearchZip(patientZip)
    }, [patientZip])

    const debouncedSetV2SearchValue = useDebounce(setV2SearchValue, 500)

    const v2Query = useGetPharmaciesV2(
      // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
      {
        PatientId: id || undefined,
        SearchValue: v2SearchValue ? adaptationSymbolsForAPI(v2SearchValue) : undefined,
        ZipCode: pharmacySearchZip || patientZip || undefined,
      },
      {
        query: {
          enabled: Boolean(isPharmacySearchDaw && v2SearchValue && v2SearchValue.trim().length > 2),
        },
      },
    )
    const v2Pharmacies = v2Query.data ?? []
    const v2SearchingDone = v2Query.isSuccess && !v2Query.isFetching

    const pharmaciesCollection = isPharmacySearchDaw ? v2Pharmacies : foundPharmaciesCollection
    const pharmacySearchingDone = isPharmacySearchDaw ? v2SearchingDone : isPharmacySearchingDone

    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    const [streetNumberFromAutocomplete, setStreetNumberFromAutocomplete] = useState('')
    const [streetNameFromAutocomplete, setStreetNameFromAutocomplete] = useState('')
    const [isContactPharmacySearchInputFocused, setIsContactPharmacySearchInputFocused] = useState(false)
    const [isAutocompleteWorked, setIsAutocimpleteWorked] = useState(false)
    const [isContactPharmaciesSearchStarted, setIsContactPharmaciesSearchStarted] = useState(false)
    const [isContactPharmacySelected, setIsContactPharmacySelected] = useState(false)
    const [isShowContactParmaciesDropdown, setIsShowContactPharmaciesDropdown] = useState(false)
    const [isAddressesDropdownMovedToContainer, setIsAddressesDropdownMovedToContainer] = useState(false)
    const [isStreetAddress1Focused, setIsStreetAddress1Focused] = useState(false)
    const [isPhoneValidationStarted, setIsPhoneValidationStarted] = useState(false)
    const [isShowPhoneGreenMark, setIsShowPhoneGreenMark] = useState(isPhoneCorrect)

    const pharmacyDropdownRef = useRef(null)
    const zipInputFocusedRef = useRef(false)
    const onSelectPharmacyDebounce = useDebounce(setIsShowContactPharmaciesDropdown, 300)

    const streetAddress1InputStyle = useMemo(
      () => ({
        marginBottom:
          streetAddress1LocalError && windowWidth < maxWindowWidthForIncreaseStreetAddress1ErrorHeight ? 65 : 44,
      }),
      [streetAddress1LocalError, windowWidth],
    )

    const zipCodeInputStyle = useMemo(
      () => ({
        marginBottom: zipCodeLocalError && windowWidth < maxWindowWidthForIncreaseZipCodeErrorHeight ? 65 : 44,
      }),
      [zipCodeLocalError, windowWidth],
    )

    useEffect(() => {
      const getWindowWidth = () => {
        setWindowWidth(window.innerWidth)
      }

      window.addEventListener('resize', getWindowWidth)

      return () => {
        window.removeEventListener('resize', getWindowWidth)
      }
    }, [])

    useEffect(() => {
      if (!isPharmacySearchDaw) return
      const el = pharmacyDropdownRef.current
      if (!el) return
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const handleMouseDown = (e) => {
        if (e.target.tagName === 'INPUT') {
          zipInputFocusedRef.current = true
        } else {
          e.preventDefault()
        }
      }
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      el.addEventListener('mousedown', handleMouseDown)
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      return () => el.removeEventListener('mousedown', handleMouseDown)
    }, [isPharmacySearchDaw])

    useEffect(() => {
      if (error === getUserFriendlyErrorMessage(errorCodes.THIS_PHONE_NUMBER_CONNOT_BE_USED)) {
        dispatchInfo(
          setContactInfoState({
            phoneLocalError: error,
            forcePhoneLocalError: error,
          }),
        )
        dispatch(setChartsError(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)))
      }
      if (error === getUserFriendlyErrorMessage(errorCodes.NAME_ALREADY_EXISTS, null, EMAIL_TEXT)) {
        dispatchInfo(
          setContactInfoState({
            emailAddressLocalError: getUserFriendlyErrorMessage(errorCodes.NAME_ALREADY_EXISTS, null, EMAIL_TEXT),
          }),
        )
        dispatch(setChartsError(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)))
      }
    }, [error])

    useEffect(() => {
      if (phoneLocalError === getUserFriendlyErrorMessage(errorCodes.PHONE_NUMBER_CONNOT_BE_AS_EMERGENCY)) {
        dispatchInfo(
          setContactInfoState({
            forcePhoneLocalError: phoneLocalError,
          }),
        )
      } else {
        setIsShowPhoneGreenMark(isPhoneCorrect)
      }
    }, [isPhoneCorrect, phoneLocalError])

    const checkPatientNumberAction = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (newPhoneCountryCode, newPhoneCountry) => {
        setIsPhoneValidationInProgress(true)
        dispatchInfo(
          setContactInfoState({
            isPhoneValidation: true,
          }),
        )
        dispatch(
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          validatePhoneNumber(
            {
              Number: `+${newPhoneCountryCode || phoneCountryCode}${phoneNumber}`,
              Prefix: `+${newPhoneCountryCode || phoneCountryCode}`,
              CountryCode: newPhoneCountry?.toUpperCase() || phoneCountry.toUpperCase(),
            },
            id,
          ),
        )
      },
      [setIsPhoneValidationInProgress, dispatchInfo, dispatch, phoneCountryCode, phoneNumber, phoneCountry, id],
    )

    useEffect(() => {
      if (isSaveClickedBeforePhoneValidation && isPhoneChanged && !isPhoneValidationStarted) {
        setIsPhoneValidationStarted(false)
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        checkPatientNumberAction()
      }
    }, [isSaveClickedBeforePhoneValidation])

    useEffect(() => {
      if (!isAddressesDropdownMovedToContainer && isStreetAddress1Focused) {
        const streetAddress1Dropdown = document.querySelector('.pac-container')
        const streetAddress1Container = document.querySelector('.edit-account-info-address-1-container')
        if (streetAddress1Container && streetAddress1Dropdown) {
          streetAddress1Container.append(streetAddress1Dropdown)
          setIsAddressesDropdownMovedToContainer(true)
        }
      }
    }, [isStreetAddress1Focused, isAddressesDropdownMovedToContainer])

    useEffect(() => {
      if (isAutocompleteWorked) {
        dispatchInfo(
          setContactInfoState({
            streetAddress1: `${
              streetNumberFromAutocomplete ? `${streetNumberFromAutocomplete} ` : ''
            }${streetNameFromAutocomplete}`,
          }),
        )
        setIsAutocimpleteWorked(false)
      }
    }, [isAutocompleteWorked])

    useEffect(() => {
      if (!isContactPharmacySearchInputFocused) {
        dispatchInfo(
          setContactInfoState({
            pharmacyValueBeforeInputBlured: pharmacyValue,
          }),
        )
        if (!zipInputFocusedRef.current) {
          onSelectPharmacyDebounce(false)
        }
        zipInputFocusedRef.current = false
      }
    }, [isContactPharmacySearchInputFocused])

    useEffect(() => {
      if (
        streetAddress1 === (currentPatientInfo?.Address?.StreetAddress1 || '') &&
        streetAddress2 === (currentPatientInfo?.Address?.StreetAddress2 || '') &&
        city === (currentPatientInfo?.Address?.City || '') &&
        stateCode === (currentPatientInfo?.Address?.StateCode || '') &&
        zipCode === (currentPatientInfo?.Address?.Zip || '')
      ) {
        setIsAddressChanged(false)
      } else {
        setIsAddressChanged(true)
      }
    }, [streetAddress1, streetAddress2, city, stateCode, zipCode])

    useEffect(() => {
      dispatchInfo(
        setContactInfoState({
          cityLocalError: '',
        }),
      )
    }, [city])

    useEffect(() => {
      dispatchInfo(
        setContactInfoState({
          stateCodeLocalError: '',
        }),
      )
    }, [stateCode])

    useEffect(() => {
      dispatchInfo(
        setContactInfoState({
          zipCodeLocalError: '',
        }),
      )
    }, [zipCode])

    const onChangePatientPhoneNumber = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        if (!isNaN(value) && value[value.length - 1] !== '.') {
          if (value === getPhoneNumberValue(currentPatientInfo?.PhoneNumber)) {
            setIsShowPhoneGreenMark(true)
            dispatchInfo(
              setContactInfoState({
                isPhoneChanged: false,
              }),
            )
          } else {
            setIsShowPhoneGreenMark(false)
            dispatchInfo(
              setContactInfoState({
                isPhoneChanged: true,
              }),
            )
          }

          dispatchInfo(
            setContactInfoState({
              phoneNumber: value,
              phoneLocalError: '',
              forcePhoneLocalError: '',
            }),
          )
        }
      },
      [currentPatientInfo?.PhoneNumber, dispatchInfo],
    )

    const onChangePatientCountry = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (code, country) => {
        dispatchInfo(
          setContactInfoState({
            isPhoneChanged:
              code !== currentPatientInfo?.PhoneNumber?.Prefix ||
              phoneNumber !== getPhoneNumberValue(currentPatientInfo?.PhoneNumber),
            phoneCountry: country.countryCode,
            phoneCountryCode: code,
            forcePhoneLocalError: '',
          }),
        )
        if (phoneNumber) {
          checkPatientNumberAction(code, country.countryCode)
        }
      },
      [checkPatientNumberAction, currentPatientInfo?.PhoneNumber, dispatchInfo, phoneNumber],
    )

    const onChangePatientStreetAddress1 = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        dispatchInfo(
          setContactInfoState({
            streetAddress1: value,
            streetAddress1LocalError: '',
          }),
        )
      },
      [dispatchInfo],
    )
    const onChangeEmailAddress = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        dispatchInfo(
          setContactInfoState({
            emailAddress: value,
            emailAddressLocalError: '',
          }),
        )
      },
      [dispatchInfo],
    )

    const onAutocomplete = useCallback(
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      ({ address_components }) => {
        // All five fields are assigned every time, so anything the new place does not carry is
        // cleared instead of keeping the previous suggestion's value.
        const addressFields = getAddressFieldsFromPlaceResult(address_components)

        setStreetNumberFromAutocomplete(addressFields.streetNumber)
        setStreetNameFromAutocomplete(addressFields.streetName)
        dispatchInfo(
          setContactInfoState({
            city: addressFields.city,
            stateCode: addressFields.stateCode,
            zipCode: addressFields.zipCode,
          }),
        )
        setIsAutocimpleteWorked(true)
      },
      [dispatchInfo],
    )

    const onChangePatientStreetAddress2 = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        dispatchInfo(
          setContactInfoState({
            streetAddress2: value,
          }),
        )
      },
      [dispatchInfo],
    )

    const onChangePatientCity = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        dispatchInfo(
          setContactInfoState({
            city: value,
            cityLocalError: '',
          }),
        )
      },
      [dispatchInfo],
    )

    const onChangePatientState = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        dispatchInfo(
          setContactInfoState({
            stateCode: value,
            stateCodeLocalError: '',
          }),
        )
      },
      [dispatchInfo],
    )

    const onChangePatientZipCode = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        const filteredValue = value
          .split('')
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          .filter((character) => !isNaN(character) || character === '-')
          .join('')

        dispatchInfo(
          setContactInfoState({
            zipCode: filteredValue,
            zipCodeLocalError: '',
          }),
        )
      },
      [dispatchInfo],
    )

    const onSetContactPharmacyValue = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (inputValue) => {
        dispatchInfo(
          setContactInfoState({
            selectedPharmacyId: null,
            pharmacyValue: inputValue,
            pharmacyLocalError: '',
          }),
        )

        if (inputValue !== pharmacyValueBeforeInputBlured) {
          setIsShowContactPharmaciesDropdown(true)
        }
        if (!inputValue) {
          setIsContactPharmaciesSearchStarted(false)
          if (isPharmacySearchDaw) {
            setV2SearchValue('')
          } else {
            // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
            dispatch(setIsPharmaciesSearchingDone())
          }
        }
        if (inputValue?.trim()?.length > 2 && isContactPharmacySearchInputFocused) {
          if (!isContactPharmaciesSearchStarted) {
            setIsContactPharmaciesSearchStarted(true)
            setIsContactPharmacySelected(false)
          }
          if (isPharmacySearchDaw) {
            debouncedSetV2SearchValue(inputValue.trim())
          } else {
            onSearchPharmaciesDebounce(id, adaptationSymbolsForAPI(inputValue))
          }
        } else if (isPharmacySearchDaw) {
          setV2SearchValue('')
        } else {
          dispatch(resetPharmacySearchList())
        }
      },
      [
        dispatchInfo,
        pharmacyValueBeforeInputBlured,
        isContactPharmacySearchInputFocused,
        dispatch,
        isContactPharmaciesSearchStarted,
        onSearchPharmaciesDebounce,
        id,
        isPharmacySearchDaw,
        debouncedSetV2SearchValue,
      ],
    )

    const onSelectPharmacy = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (selectedPharmacyConfig) => {
        dispatchInfo(
          setContactInfoState({
            pharmacyValue: setPharmacyAddressValue(selectedPharmacyConfig),
            selectedPharmacyValue: setPharmacyAddressValue(selectedPharmacyConfig),
            selectedPharmacyId: selectedPharmacyConfig.PharmacyId,
            selectedPharmacyConfig,
          }),
        )
      },
      [dispatchInfo],
    )

    const onChangeCountryCode = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        dispatchInfo(
          setContactInfoState({
            phoneCountryCode: value,
          }),
        )
      },
      [dispatchInfo],
    )

    const onChangeIsPhoneCorrectValue = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        dispatchInfo(
          setContactInfoState({
            isPhoneCorrect: value,
          }),
        )
      },
      [dispatchInfo],
    )

    const onChangePhoneError = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        dispatchInfo(
          setContactInfoState({
            phoneLocalError: value,
          }),
        )
      },
      [dispatchInfo],
    )

    return (
      <EditCardAccountInfo className='edit-account-info-card' title={CONTACT_TEXT}>
        <PhoneInput
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          id='edit-account-info-contact-phone'
          className='edit-account-info-contact-phone'
          inputLabel={`${INTAKE_FORM_TYPE_PHONE_NUMBER_TEXT}${ASTERISK_TEXT}`}
          setCountryCode={onChangeCountryCode}
          phoneCountry={phoneCountry}
          phoneNumber={phoneNumber}
          phoneCountryCode={phoneCountryCode}
          onChangeCountry={onChangePatientCountry}
          onChangeNumber={onChangePatientPhoneNumber}
          checkPhone={checkPatientNumberAction}
          isPhoneCorrect={isShowPhoneGreenMark}
          isOldNumberCorrect={isOldNumberCorrect}
          setIsPhoneCorrect={onChangeIsPhoneCorrectValue}
          setPhoneError={onChangePhoneError}
          error={phoneLocalError || forcePhoneLocalError}
          loading={phoneNumberValidationLoading}
          setIsPhoneValidationStarted={setIsPhoneValidationStarted}
          isPhoneValidationStarted={isPhoneValidationStarted}
          isPhoneValidation={isPhoneValidation}
          disabled={!isAlowEditPhoneNumber}
        />
        <InputText
          containerStyle={mainInputContainerStyle}
          label={`${INTAKE_FORM_TYPE_EMAIL_TEXT}*`}
          view='email'
          value={emailAddress}
          setValue={onChangeEmailAddress}
          localError={emailAddressLocalError}
          disabled={!isCanEditEmail}
          isDisableAutocomplete
        />
        <div className='edit-account-info-inputs-row'>
          <div className='edit-account-info-address-1-container'>
            <InputText
              containerStyle={{ ...mainInputContainerStyle, ...streetAddress1InputStyle }}
              label={`${STREET_ADDRESS_1_TEXT}${ASTERISK_TEXT}`}
              setValue={onChangePatientStreetAddress1}
              value={streetAddress1}
              isError={streetAddress1LocalError}
              localError={streetAddress1LocalError}
              isGoogleAutoComplete
              googleApiKey={env.googleAPIKey}
              onAutocomplete={onAutocomplete}
              onSetIsFocused={setIsStreetAddress1Focused}
            />
          </div>
          <InputText
            containerStyle={mainInputContainerStyle}
            label={STREET_ADDRESS_2_TEXT}
            view='visitType'
            setValue={onChangePatientStreetAddress2}
            value={streetAddress2}
          />
        </div>
        <InputText
          containerStyle={mainInputContainerStyle}
          label={`${CITY_TEXT}${ASTERISK_TEXT}`}
          isError={cityLocalError}
          localError={cityLocalError}
          view='visitType'
          setValue={onChangePatientCity}
          value={city}
        />
        <div className='edit-account-info-inputs-row'>
          <Dropdown
            isStateDropdown
            options={sortedStatesAddressDropdownList}
            containerStyle={{ ...mainInputContainerStyle, ...statesDropdownContainerStyle }}
            label={`${STATE_TEXT}${ASTERISK_TEXT}`}
            setValue={onChangePatientState}
            isError={stateCodeLocalError}
            localError={stateCodeLocalError}
            value={stateCode}
          />
          <InputText
            containerStyle={{ ...mainInputContainerStyle, ...zipCodeInputStyle }}
            label={`${ZIP_CODE_TEXT}${ASTERISK_TEXT}`}
            view='visitType'
            isError={zipCodeLocalError}
            localError={zipCodeLocalError}
            setValue={onChangePatientZipCode}
            value={zipCode}
          />
        </div>
        <div className='edit-account-info-pharmacy-input-main-wrapper'>
          <InputText
            label={PREFERRED_PHARMACY_TEXT}
            onSetIsFocused={setIsContactPharmacySearchInputFocused}
            containerStyle={mainInputContainerStyle}
            setValue={onSetContactPharmacyValue}
            value={pharmacyValue || ''}
            isError={isAddressValid ? !!pharmacyLocalError : false}
            localError={isAddressValid ? pharmacyLocalError : ''}
            view='visitType'
            isSearch
            disabled={!isAddressValid}
          />
          {(
            isContactPharmaciesSearchStarted &&
            !isContactPharmacySelected &&
            pharmacySearchingDone &&
            isShowContactParmaciesDropdown &&
            !pharmacyLocalError
          ) ?
            <div ref={pharmacyDropdownRef} className='edit-account-info-list-of-pharmacies-dropdown'>
              {isPharmacySearchDaw ?
                <PharmacyZipFilter
                  className='m-sp-2'
                  zipCode={pharmacySearchZip}
                  patientZipFallback={patientZip}
                  onSave={setPharmacySearchZip}
                />
              : null}
              {
                pharmaciesCollection?.length ?
                  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                  pharmaciesCollection.map((pharmacyListItem, idx) => (
                    // @ts-expect-error TS2741 -- MIGRATION: not approved, fix when encountered
                    <PharmacyDropdownItem
                      key={pharmacyListItem.PharmacyId}
                      currentPharmacy={pharmacyListItem}
                      title={pharmacyListItem.Name}
                      description={setPharmacyString(pharmacyListItem?.Address)}
                      distance={pharmacyListItem.DistanceMiles}
                      onSelectPharmacy={onSelectPharmacy}
                      isTheLastItem={idx === pharmaciesCollection.length - 1}
                    />
                  ))
                  // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
                : <PharmacyDropdownItem title={NO_RESULTS_TEXT} isEmpty isTheLastItem />
              }
            </div>
          : null}
        </div>
      </EditCardAccountInfo>
    )
  },
)
